import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProdottiPage = lazy(() => import('../pages/prodotti/page'));
const OffertePage = lazy(() => import('../pages/offerte/page'));
const AziendaPage = lazy(() => import('../pages/azienda/page'));
const ContattiPage = lazy(() => import('../pages/contatti/page'));
const MediaPage = lazy(() => import('../pages/media/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/prodotti',
    element: <ProdottiPage />,
  },
  {
    path: '/offerte',
    element: <OffertePage />,
  },
  {
    path: '/azienda',
    element: <AziendaPage />,
  },
  {
    path: '/contatti',
    element: <ContattiPage />,
  },
  {
    path: '/media',
    element: <MediaPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;